/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../../../../theme';
import { ILabelColor, LabelColor } from '../../../../../constants/labelColor';

export const LabelEditorListContainerStyled = styled.div.attrs({
    className: 'label-editor__item-container',
})`
    display: flex;
    flex-direction: column;
`;

export const LabelEditorItemStyled = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colors.labelEditorItemBorder};
    box-sizing: border-box;
    padding-top: 8px;
    padding-bottom: 8px;

    &:last-child {
        border-bottom: none;
    }

    .label-editor__item-text_bold {
        font-weight: bold;
        line-height: 1;
        background: transparent;
    }

    .label-editor__item-checkbox {
        margin-left: 8px;
    }
`;

export const LabelEditorSearchNotFound = styled.div`
    padding: 8px;
    ${fonts.textMain};
`;

export const LabelEditorNameStyled = styled.div`
    flex: 1;
    padding-left: 8px;
    position: relative;
    top: 2px;
    width: 100%;
    min-width: 1px; // flex magic for width
`;

export const LabelEditorColorStyled = styled.div<{ color: ILabelColor }>`
    margin-left: 8px;
    min-width: 9px;
    min-height: 9px;
    border-radius: 50%;
    ${({ color }) => color ? `background-color:${LabelColor[color]};` : ''}
`;

export const LabelEditorRemoveItemStyled = styled.div.attrs(({ disabled }: { disabled?: boolean }) => ({
    className: `${disabled ? 'disabled' : ''}`,
}))<{ disabled?: boolean }>`
    cursor: pointer;
    padding-left: 8px;
    padding-right: 8px;

    &.disabled {
        pointer-events: none;
        cursor: auto;
    }
`;
